module.exports = __webpack_public_path__ + "static/media/video_verfication_audio.444ca9d1.mp3";